export default __webpack_public_path__ + "static/media/home_carousel_6.f5444342.png";